// extracted by mini-css-extract-plugin
export default {"container":"---------packages-corgi-x-src-components-CollapsibleCard-CollapsibleCard-module__container"};